import ToolbarDate from './ToolbarDate'
import ToolbarRoot from './ToolbarRoot'
import ToolbarToday from './ToolbarToday'

export const RootDateComponent = (props) => <ToolbarDate {...props}/>
export const RootToolbarComponent = (props) => <ToolbarRoot {...props}/>
export const TodayButtonComponent = (props) => <ToolbarToday {...props}/>
